module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="fmcy-search-clear-filters-x-btn">X&nbsp;</span><span class="fmcy-selected-vendor-name">'+
((__t=( vendorName ))==null?'':__t)+
'</span>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/subfilters/vendor-select-selected/vendor-selected.html
 ** module id = 663
 ** module chunks = 1 7 43 115
 **/